export default __webpack_public_path__ + "static/media/more-white.ba050e2a.svg";